import objectPath from 'object-path';
import React from 'react'
import { connect as formikConnect } from 'formik'
import PropTypes from 'prop-types'

import FormField from './FormField'
 
// ErrorMessage that supports deep props
@formikConnect
class ErrorMessage extends React.Component {
	render() {
		const { formik, name } = this.props;
		const error = objectPath(formik.errors).get(name);
		const touched = objectPath(formik.touched).get(name);

		if(typeof error === 'string' && touched) {
			return <div>{error}</div>
		}
		else {
			return '';
		}
	}
}

@formikConnect
class FieldGroup extends React.Component {

	static propTypes = {
		isEditing: PropTypes.bool,
	};

	static defaultProps = {
		isEditing: true,
	}

	render() {
		const { 
			label,
			name,
			showOnNew,
			isEditing,
			isNew,
			formik,
			show,
			...props,
		} = this.props;


		// Determine if it is new and showOnNew === false
		var visible = !(isNew && showOnNew === false);

		// call show function if it exists
		if(typeof show === 'function') {
			visible = show({...this.props, ...formik});
		}

		if(!visible) return '';

		return (
			<div className='FieldGroup' data-name={name}>
				{
					label
					&& <label>{label}</label>
				}
				<FormField isEditing={isEditing} name={name} {...props} />
				{
					isEditing &&
			    <div className="FieldGroup-error">
			    	<ErrorMessage
			      	className="field-error"
			      	name={name}
			    	/>
			    </div>
				}
			</div>
		)
	}
}

export default FieldGroup;


// WEBPACK FOOTER //
// ./src/modules/form/components/FieldGroup.jsx